module.exports = __webpack_public_path__ + "img/recent-work-05.cd67209f.jpg";